import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "../../../config";

export const useDetails = () => {
  const [loading, setLoading] = useState(false);
  const [removeBgLoading, setRemoveBgLoading] = useState({
    loading: false,
    ids: [],
  });
  const [catalog, setCatalog] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const handleProductSelection = (productId) => {
    if (selectedProducts.includes(productId)) {
      setSelectedProducts(selectedProducts.filter((id) => id !== productId));
    } else {
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  const handleSelectAllProducts = () => {
    if (selectedProducts.length === catalog.products.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(catalog.products.map((product) => product._id));
    }
  };

  const handleSetMultipleActive = async (productIds) => {
    try {
      await fetch(`${API}/catalogs/products/mark-available`, {
        method: "PUT",
        body: JSON.stringify({ productIds }),
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleEditCatalog = async (data) => {
    try {
      setLoading(true);
      await fetch(`${API}/catalogs/${id}`, {
        method: "PUT",
        body: JSON.stringify(data),
      });
      getCatalog();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveMultipleBg = async (productIds) => {
    try {
      setRemoveBgLoading({
        loading: true,
        ids: productIds,
      });
      await fetch(`${API}/catalogs/remove-background/bulk`, {
        method: "PUT",
        body: JSON.stringify({ productIds }),
      });
      await sleep(2000);
      getCatalog();
      setSelectedProducts([]);
    } catch (error) {
      console.log(error);
    }
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleDeleteMultipleProducts = async (productIds) => {
    try {
      await fetch(`${API}/Admin/addProduct/delete/bulk`, {
        method: "PUT",
        body: JSON.stringify({
          productIds: productIds,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      sleep(2000);
      getCatalog();
      setSelectedProducts([]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveBg = async (productId, imageIndex) => {
    setRemoveBgLoading((prev) => ({
      loading: true,
      ids: prev.ids.includes(productId) ? prev.ids : [...prev.ids, productId],
    }));
    const res = await fetch(
      `${API}/catalogs/remove-background/${productId}/${imageIndex}`,
      {
        method: "PATCH",
      }
    );
    const json = await res.json();
    setCatalog({
      ...catalog,
      products: catalog.products.map((product) => {
        if (product._id === productId) {
          return {
            ...product,
            image: json.image,
          };
        }
        return product;
      }),
    });
    getCatalog();
    setRemoveBgLoading((prev) => {
      const ids = prev.ids.filter((id) => id !== productId);
      return {
        loading: false,
        ids,
      };
    });
  };

  const { id } = useParams();

  const getCatalog = async () => {
    setLoading(true);
    const response = await fetch(`${API}/catalogs/${id}`);
    const json = await response.json();
    setCatalog(json);
    setLoading(false);
  };

  useEffect(() => {
    getCatalog();
  }, []);

  return {
    catalog,
    getCatalogLoading: loading,
    handleProductSelection,
    handleRemoveBg,
    selectedProducts,
    removeBgLoading,
    handleRemoveMultipleBg,
    handleDeleteMultipleProducts,
    handleSelectAllProducts,
    handleEditCatalog,
    handleSetMultipleActive,
  };
};
